<canvas
  baseChart
  [data]="barChartData"
  [options]="barChartOptions"
  [legend]="false"
  type="bar"
  *ngIf="barChartData"
  (chartClick)="onChartClick($event)"
>
</canvas>
